import React from 'react';
import { is } from '../../../services/classify';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Slice Image Component
 * @param children {ReactNode} Custom children for Slice Image
 * @param src {string} Image source
 * @param alt {string} Image alt
 * ------------------ WEB PROPERTIES ---------------------
 * @param rounded {boolean} Rounded Slice Image
 * @param className {string} Additionnal CSS Classes
 */
const SliceImage = ({ children, className, src, alt, rounded, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('slice-image', className));
    if (children) {
        return (React.createElement("div", { className: classes, ...others }, children));
    }
    return (React.createElement("div", { className: classes, ...others },
        React.createElement("div", { className: hashClass(styled, clsx('image')) },
            React.createElement("img", { className: hashClass(styled, clsx(rounded && is('rounded')) || ''), src: typeof src === 'string' ? src : '', alt: alt }))));
};
export default SliceImage;
//# sourceMappingURL=SliceImage.js.map